import { render, staticRenderFns } from "./TableOptionsDropdown.vue?vue&type=template&id=3165fd50&scoped=true&"
import script from "./TableOptionsDropdown.vue?vue&type=script&lang=js&"
export * from "./TableOptionsDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3165fd50",
  null
  
)

export default component.exports